import {Component, OnInit} from '@angular/core';
import {DomSanitizer, Meta, SafeResourceUrl, Title} from "@angular/platform-browser";
import {AppConstants} from "../../../shared/constants/app-constant";
import {ActivatedRoute, Router} from "@angular/router";

@Component({
    selector: 'app-research',
    templateUrl: './research.component.html',
    styleUrls: ['./research.component.scss']
})
export class ResearchComponent implements OnInit {
    pageTitle: string;
    schools = AppConstants.schools;
    index = 0;
    activeIndex: number | null = null;
    openedIndex: number | null = null;
    sanitizedPdfUrl: SafeResourceUrl | null = null;
    mous = [
        {
            title: 'Memorandum of Understanding (MoU) executed for Research between, “ARNI University” and Future Tech Wizards LLP.',
            color: '#22C55E',
            description: '',
            downloadLabel: 'MoU with Future Tech Wizards LLP',
            downloadUrl: 'assets/pdf/arni-university-future-tech-wizard-mou.pdf',
            openExternally: false
        },
        {
            title: 'Memorandum of Understanding (MoU) executed for Research between, “ARNI University” and Virtual Labs IIT Delhi.',
            color: '#22C55E',
            description: '',
            downloadLabel: 'MoU with Virtual Labs IIT Delhi',
            downloadUrl: 'assets/pdf/virtual-labs-it.pdf',
            openExternally: false
        },
        {
            title: 'Memorandum of Understanding (MoU) executed for Research between, “ARNI University” and INTI University, Malaysia.',
            color: '#22C55E',
            description: '',
            downloadLabel: 'MoU with INTI University, Malaysia',
            downloadUrl: 'assets/pdf/inti-university.pdf',
            openExternally: false
        }
    ];

    publications = [
        {
            author: "Praveen Uppu",
            title: "Efficacy of Mobile Phone Technology for Managing Side Effects Associated with Chemotherapy among Cancer Patients: A Systematic Review and Meta-Analysis"
        },
        {
            author: "Rohit Kumar, Piyush Kumar Gupta, Soumya Pandit, Niraj Kumar Jha",
            title: "Synthesis and characterization of biocompatible bimetallic-semi-aromatic polyester hybrid nanocomposite"
        },
        {
            author: "Piyush Kumar Gupta",
            title: "Synthesis, Characterization and Remedial Action of Biogenic Silver Nanoparticles and Chitosan-Silver Nanoparticles against Bacterial Pathogens"
        },
        {
            author: "Piyush Kumar Gupta, Niraj Kumar Jha",
            title: "Aptameric Nanobiosensors for the Diagnosis of COVID-19: An Update"
        },
        {
            author: "Soumya Pandit",
            title: "Phytocompound Mediated Blockage of Quorum Sensing Cascade in ESKAPE Pathogens"
        },
        {
            author: "Saurabh Kumar Jha, Madhan Jeyaraman, Rashmi Jain",
            title: "A Step Toward Optimizing Regenerative Medicine Principle to Combat COVID-19"
        },
        {
            author: "Niraj Kumar Jha and Saurav Kumar Jha",
            title: "Recent Advances in Chronotherapy Targeting Respiratory Diseases"
        },
        {
            author: "Niraj Kumar Jha and Piyush Kumar Gupta",
            title: "Microfluidic Chips: Recent Advances, Critical Strategies in Design, Application and Future Perspectives"
        },
        {
            author: "Okoye F.N, Durgaprasad J, Singh N.B.",
            title: "Fly ash/Kaolin based geopolymer green concretes and their mechanical properties (2015) Vol.5 Page.739-744"
        },
        {
            author: "Okoye F.N, Durgaprasad J, Singh N.B.",
            title: "Mechanical properties of alkali activated flyash/Kaolin based geopolymer concrete Construction and Building Materials (2015) Vol.98 Page.685-691"
        }
    ];
    hostelImages = [
        {image_url: './assets/img/hostel-facilities/hostel-image.jpg', name: 'Hostel image'},
        {image_url: './assets/img/hostel-facilities/badminton-court.jpg', name: 'Badminton court'},
        {image_url: './assets/img/hostel-facilities/hostel-view.jpg', name: 'Hostel view'},
        {image_url: './assets/img/hostel-facilities/hostel-view-front.jpg', name: 'Hostel view front'},
    ];
    messImages = [
        {image_url: './assets/img/mess-facilities/mess-image.jpg', name: 'Mess boys'},
        {image_url: './assets/img/mess-facilities/mess-food.jpg', name: 'Mess food'},
        {image_url: './assets/img/mess-facilities/mess-stall.jpg', name: 'Mess stall'},
        {image_url: './assets/img/mess-facilities/mess-boys.jpg', name: 'Mess boys'},
    ];
    journals = [
        {
            title: 'ARNI JOURNAL OF SCIENCE & TECHNOLOGY (AJST)',
            description:
                'AJST publishes multidisciplinary research papers from leading universities and research institutions.',
            open: false,
        },
        {
            title: 'ARNI BUSINESS AND MANAGEMENT REVIEW (ABMR)',
            description:
                'ABMR focuses on contemporary business, economic, and management research.',
            open: false,
        },
        {
            title: 'ARNI LAW AND POLICY REVIEW (ALPR)',
            description:
                'ALPR is a bi-annual peer-reviewed journal that explores legal and policy frameworks globally.',
            open: false,
        },
    ];
    recruiters = [
        {name: "Adani Wilmar", logo: "assets/img/companies/adani_wilmar.png"},
        {name: "Amar Ujala", logo: "assets/img/companies/amarujala.png"},
        {name: "Amazon", logo: "assets/img/companies/Amazon.png"},
        {name: "CMC", logo: "assets/img/companies/cmc-logo_0.png"},
        {name: "Dish TV", logo: "assets/img/companies/Dish_TV_2.png"},
        {name: "Future Group", logo: "assets/img/companies/FutureGroup.png"},
        {name: "HCL", logo: "assets/img/companies/hcl.png"},
        {name: "ICICI", logo: "assets/img/companies/icici_securities.png"},
        {name: "Sleepwell", logo: "assets/img/companies/sleepwell.png"},
        {name: "SYNTEL", logo: "assets/img/companies/syntel2.png"},
        {
            name: "Tech Mahindra",
            logo: "assets/img/companies/Tech_Mahindra_New_Logo1.png",
        },
        {name: "Vodafone", logo: "assets/img/companies/Vodafone_logo.png"},
        {name: "Zee TV", logo: "assets/img/companies/Zee_TV_2011.png"},
        {name: "Genpact", logo: "assets/img/companies/zenpact.png"},
        {name: "Reliance", logo: "assets/img/companies/amarujala.png"},
    ];

    researchDownloads: any = [
        {
            title: 'Ph.D. Notification 2025-26',
            description: 'Official notification for Ph.D. admissions for the academic year 2025-26, including eligibility, application deadlines, and guidelines.',
            pdfFileName: 'phd-notification-2025-26.pdf'
        },
        {
            title: 'Ph.D. Entrance Test Form 2025-26',
            description: 'Application form for the Ph.D. Entrance Test for the academic year 2025-26. Candidates must fill and submit this form to appear for the entrance exam.',
            pdfFileName: 'phd-entrance-test-form-2025-26.pdf'
        }
    ];

    pdfUrl: SafeResourceUrl | null = null;
    mouPdfUrl: SafeResourceUrl | null = null;

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private sanitizer: DomSanitizer
    ) {
        this.route.data.subscribe(params => {
            if (params && params.title) {
                this.pageTitle = params.title;
            }
        });
    }

    nextSlide() {
        if (this.index < this.recruiters.length - 3) {
            this.index++;
        }
    }

    prevSlide() {
        if (this.index > 0) {
            this.index--;
        }
    }


    toggleJournal(index: number) {
        this.journals[index].open = !this.journals[index].open;
    }

    scrollToContent() {
        const tabs = document.querySelectorAll('.tab-link');
        tabs.forEach(tab => {
            tab.addEventListener('click', (event: Event) => {
                event.preventDefault();
                tabs.forEach(t => t.classList.remove('active-tab'));
                const targetTab = event.target as HTMLElement;
                targetTab.classList.add('active-tab');
                const targetId = targetTab.getAttribute('href')?.substring(1);
                if (targetId) {
                    const targetElement = document.getElementById(targetId);
                    if (targetElement) {
                        targetElement.scrollIntoView({behavior: 'smooth', block: 'center'});
                    }
                }
            });
        });
    }

    ngOnInit(): void {
        this.scrollToContent();
        const pdfLink = 'assets/img/research-pdfs/arni-university-phd-regulations.pdf';
        this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(pdfLink);
    }

    goTo(url: string) {
        this.router.navigateByUrl(url);
    }

    toggleAccordion(index: number): void {
        if (this.activeIndex === index) {
            this.activeIndex = null;
        } else {
            this.activeIndex = index;
        }
    }

    closePdfModal(): void {
        this.mouPdfUrl = null;
        this.sanitizedPdfUrl = null;
    }

    toggleMouAccordion(index: number): void {
        this.openedIndex = this.openedIndex === index ? null : index;
    }

    openPdfModal(event: Event, url: string) {
        event.preventDefault();
        if (url.startsWith('http') && !url.includes(window.location.hostname)) {
            window.open(url, '_blank');
            return;
        }
        this.mouPdfUrl = url;
        this.sanitizedPdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    }
}
